import type { ComponentOverride } from '../types';

export const MuiCardContent: ComponentOverride<'MuiCardContent'> = {
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 24,
      },
    },
  },
};
